class EnvHelper {
  get extensionPrefix() {
    return 'huixie'
  }

  get isProd() {
    return process.env.NODE_ENV === 'production'
  }

  get productName() {
    return '会写'
  }

  get host() {
    return process.env.REACT_APP_HOST
  }

  get webHost() {
    return process.env.REACT_APP_WEB_HOST
  }

  get apiHost() {
    return this.webHost
  }

  get apiBasePath() {
    return process.env.REACT_APP_API_BASE_PATH
  }
}

export const envHelper = new EnvHelper()
